<template>
  <section class="section-horizon section">
    <div class="container">
      <div class="grid-two-columns">
        <h2 class="section__title">
          {{ $t('lnd.horizon.title') }}
        </h2>

        <div class="grid-two-columns__col-content">
          <p class="section__text">
            {{ $t('lnd.horizon.descr') }}
          </p>
        </div>
      </div>

      <div class="section-horizon__line-block line-block" ref="container">
        <ul class="line-block__items">
          <li
            v-for="(block, index) in blocks"
            :key="`block-${index}`"
            class="line-block__item"
            :class="{
              'line-block__item--active': index === currentBlock,
              'line-block__item_check': block.check,
            }"
            @click="setCurrentBlock(index)"
            @mouseenter="setCurrentBlock(index)"
          >
            <div class="line-block__item-title-wrapper">
              <p class="line-block__item-title">{{ block.title }}</p>
              <p class="line-block__item-text">{{ block.text }}</p>
            </div>
            <div class="line-block__point"></div>
            <p class="line-block__item-date">{{ block.date }}</p>
          </li>
        </ul>

        <div class="line-block__timeline">
          <!-- <p class="line-block__timeline-text">{{ $t('More') }}</p> -->
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'LndHorizon',
  data: () => ({
    currentBlock: null,
  }),
  computed: {
    blocks() {
      return [
        {
          title: this.$t('lnd.horizon.q1.title'),
          text: "",
          date: 'Q1 2025',
          check: true,
        },
        {
          title: this.$t('lnd.horizon.q2.title'),
          text: "",
          date: 'Q2 2025',
          check: true,
        },
        {
          title: this.$t('lnd.horizon.q3.title'),
          text: "",
          date: 'Q3 2025',
          check: true,
        },
        {
          title: this.$t('lnd.horizon.q4.title'),
          text: "",
          date: 'Q4 2025',
          check: false,
        },
        {
          title: this.$t('lnd.horizon.q5.title'),
          text: "",
          date: 'Q1 2026',
          check: false,
        },
        {
          title: this.$t('lnd.horizon.q6.title'),
          text: "",
          date: 'Q2 2026',
          check: false,
        },
        {
          title: this.$t('lnd.horizon.q7.title'),
          text: "",
          date: 'Q3 2026',
          check: false,
        },
        {
          title: this.$t('lnd.horizon.q8.title'),
          text: "",
          date: 'Q4 2026',
          check: false,
        },
        {
          title: this.$t('lnd.horizon.q9.title'),
          text: "",
          date: 'Q1 2027',
          check: false,
        },
      ]
    }
  },
  methods: {
    setCurrentBlock(block) {
      this.currentBlock = block;
    }
  },
  mounted() {
    const currentBlock = this.$refs.currentBlock;
    const container = this.$refs.container;

    if (currentBlock) {
      container.scroll({
        left: currentBlock.offsetLeft - ((window.innerWidth / 2) - (currentBlock.clientWidth / 2)),
        behavior: 'smooth'
      })
    }
  },
}
</script>

<!-- <script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class LndHorizon extends Vue {}
</script> -->
